import { render, staticRenderFns } from "./Box3.vue?vue&type=template&id=cf17c854&scoped=true&"
import script from "./Box3.vue?vue&type=script&lang=js&"
export * from "./Box3.vue?vue&type=script&lang=js&"
import style0 from "./Box3.vue?vue&type=style&index=0&id=cf17c854&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf17c854",
  null
  
)

export default component.exports